<template>
  <v-dialog v-model="dialog" max-width="1000">
    <v-card :prepend-icon="mdiPackageVariantClosed" :title="formTitle">
      <v-form ref="form" @submit.prevent>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('reference') + ' *'"
                v-model="editedItem.reference"
                :rules="globalRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.lppr')"
                v-model="editedItem.lppr"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-switch
                v-model="editedItem.active"
                color="#ffb500"
                :label="$t('admin.active')"
                hide-details
              ></v-switch>
            </v-col>

            <v-col cols="12" sm="6">
              <v-textarea
                :label="$t('description') + ' *'"
                v-model="editedItem.description"
                :rules="globalRules"
                required
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="6">
              <v-textarea
                :label="$t('description-local')"
                v-model="editedItem.descriptionLocal"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.price') + ' *'"
                v-model="editedItem.price"
                :rules="priceRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.current-cost') + ' *'"
                v-model="editedItem.currentCost"
                :rules="priceRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('vat')"
                v-model="editedItem.tva"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.currency') + ' *'"
                v-model="editedItem.currency"
                required
                :rules="globalRules"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.franchise') + ' *'"
                v-model="editedItem.franchise"
                :items="franchises"
                @update:search="debouncedUpdateFranchises"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.franchise-group') + ' *'"
                v-model="editedItem.franchiseGroup"
                :items="franchiseGroups"
                @update:search="debouncedUpdateFranchiseGroups"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.sub-franchise') + ' *'"
                v-model="editedItem.subFranchise"
                :items="subFranchises"
                @update:search="debouncedUpdateSubFranchises"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.gim-brand') + ' *'"
                v-model="editedItem.gimBrand"
                :items="gimBrands"
                @update:search="debouncedUpdateGimBrands"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.gim-item-type') + ' *'"
                v-model="editedItem.gimItemType"
                :items="gimItemTypes"
                @update:search="debouncedUpdateGimItemTypes"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.gim-product-line') + ' *'"
                v-model="editedItem.gimProductLine"
                :items="gimProductLines"
                @update:search="debouncedUpdateGimProductLines"
                item-title="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.gim-sub-brand') + ' *'"
                v-model="editedItem.gimSubBrand"
                :items="gimSubBrands"
                @update:search="debouncedUpdateGimSubBrands"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.sapg') + ' *'"
                v-model="editedItem.sapg"
                :items="sapgs"
                @update:search="debouncedUpdateSapgs"
                item-title="name"
                item-value="id"
                :rules="globalRules"
                required
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-autocomplete
                :label="$t('admin.target-product-group') + ' *'"
                v-model="editedItem.targetProductGroup"
                :items="targetProductGroups"
                @update:search="debouncedUpdateTargetProductGroups"
                item-title="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.gim-id') + ' *'"
                v-model="editedItem.gimID"
                :rules="gimIDRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.gim-pack-content') + ' *'"
                v-model="editedItem.gimPackContent"
                :rules="gimPackContentRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-switch
                v-model="editedItem.gimSterilityFlag"
                color="#ffb500"
                :rules="gimSterilityFlagRules"
                :true-value="1"
                :false-value="0"
                :label="$t('admin.gim-sterility-flag') + ' *'"
                required
              ></v-switch>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.gim-uom') + ' *'"
                v-model="editedItem.gimUOM"
                :rules="globalRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.gtin-code') + ' *'"
                v-model="editedItem.gtinCode"
                :rules="globalRules"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="6">
              <v-text-field
                :label="$t('admin.primary-uom') + ' *'"
                v-model="editedItem.primaryUOM"
                :rules="globalRules"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            :text="$t('close')"
            variant="plain"
            @click="$emit('close')"
          ></v-btn>

          <v-btn
            color="#ffb500"
            type="submit"
            :text="$t('save')"
            variant="tonal"
            @click="save"
          ></v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import paginations from "@/mixins/paginations";
import { mdiPackageVariantClosed, mdiPencil } from "@mdi/js";
import _ from "lodash"; // Importer lodash

export default {
  name: "AddEditProduct",
  props: {
    modelDialog: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [paginations],
  data() {
    return {
      mdiPackageVariantClosed,
      mdiPencil,
      globalRules: [
        (value) => {
          if (value) return true;
          return this.$t("rules.required");
        },
      ],
      priceRules: [
        (value) => {
          if (value === 0) return true;
          if (!value) return this.$t("rules.required");
          if (isNaN(value) || parseFloat(value) < 0)
            return this.$t("rules.positive-number");
          return true;
        },
      ],
      gimIDRules: [
        (value) => {
          if (!value) return this.$t("rules.required");
          if (!Number.isInteger(Number(value)) || Number(value) <= 0)
            return this.$t("rules.integer");
          return true;
        },
      ],
      gimPackContentRules: [
        (value) => {
          if (value === 0) return true;
          if (!value) return this.$t("rules.required");
          if (!Number.isInteger(Number(value))) return this.$t("rules.integer");
          return true;
        },
      ],
      gimSterilityFlagRules: [
        (value) => {
          if (value === 0 || value === 1) return true;
          return this.$t("rules.required");
        },
      ],
    };
  },
  created() {
    // Déclarer une méthode débouncée avec un paramètre supplémentaire
    this.debouncedUpdateFranchises = _.debounce(
      (item) => this.updateFields(item, "franchises"),
      300,
    );
    this.debouncedUpdateFranchiseGroups = _.debounce(
      (item) => this.updateFields(item, "franchiseGroups"),
      300,
    );
    this.debouncedUpdateSubFranchises = _.debounce(
      (item) => this.updateFields(item, "subFranchises"),
      300,
    );
    this.debouncedUpdateGimBrands = _.debounce(
      (item) => this.updateFields(item, "gimBrands"),
      300,
    );
    this.debouncedUpdateGimItemTypes = _.debounce(
      (item) => this.updateFields(item, "gimItemTypes"),
      300,
    );
    this.debouncedUpdateGimProductLines = _.debounce(
      (item) => this.updateFields(item, "gimProductLines"),
      300,
    );
    this.debouncedUpdateGimSubBrands = _.debounce(
      (item) => this.updateFields(item, "gimSubBrands"),
      300,
    );
    this.debouncedUpdateSapgs = _.debounce(
      (item) => this.updateFields(item, "sapgs"),
      300,
    );
    this.debouncedUpdateTargetProductGroups = _.debounce(
      (item) => this.updateFields(item, "targetProductGroups"),
      300,
    );
  },
  computed: {
    dialog: {
      get() {
        return this.modelDialog;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    ...mapState({
      editedId: (state) => state.products.editedId,
      franchises: (state) => state.franchises.items,
      franchiseGroups: (state) => state.franchiseGroups.items,
      subFranchises: (state) => state.subFranchises.items,
      gimBrands: (state) => state.gimBrands.items,
      gimItemTypes: (state) => state.gimItemTypes.items,
      gimProductLines: (state) => state.gimProductLines.items,
      gimSubBrands: (state) => state.gimSubBrands.items,
      sapgs: (state) => state.sapgs.items,
      targetProductGroups: (state) => state.targetProductGroups.items,
    }),
    editedItem: {
      get() {
        return this.$store.state.products.editedItem;
      },
      set(value) {
        this.$store.commit("products/setEditedItem", value);
      },
    },
    formTitle() {
      return this.editedId === -1
        ? this.$t("admin.new-product")
        : this.$t("admin.edit-product");
    },
  },
  methods: {
    updateFields(item, search) {
      this.searchBack(item, 500, search, false);
    },
    formatedDate(inputDate) {
      // Convertir en objet Date
      const date = new Date(inputDate);

      // Extraire le jour, le mois et l'année
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Les mois commencent à 0
      const year = date.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
    },
    close() {
      this.$emit("close");
    },
    save() {
      const valid = this.$refs.form.isValid;
      if (valid) {
        if (this.editedId === -1) {
          this.$store
            .dispatch("products/saveEditedItem")
            .then(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.success.product-create"),
                color: "success",
              });
              this.close();
            })
            .catch(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.error.product-create"),
                color: "error",
              });
              this.close();
            });
        } else {
          this.$store
            .dispatch("products/updateEditedItem")
            .then(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.success.product-update"),
                color: "success",
              });
              this.close();
            })
            .catch(() => {
              this.$store.dispatch("showSnackbar", {
                message: this.$t("alert.error.product-update"),
                color: "error",
              });
              this.close();
            });
        }
      }
    },
  },
};
</script>
